import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SDCXUninstallWindows() {
    return (
        <React.Fragment>
            <p>
                Uninstalling the SDCX Server on Windows requires you to manually uninstall the Signiant SDCX Server
                software as well as its supporting applications.
            </p>
            <p>To uninstall the Signiant SDCX Server:</p>
            <ol>
                <li>
                    {' '}
                    From the Start Menu, click <strong>Settings</strong>.
                </li>
                <li>
                    {' '}
                    Open the <strong>Apps</strong> settings.
                </li>
                <li> Uninstall Signiant SDCX Server to remove the server software and all related applications.</li>
            </ol>
            <p>
                To reinstall the server after removal, follow the installation procedure using a new registration key.
            </p>
        </React.Fragment>
    );
}

SDCXUninstallWindows.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SDCXUninstallWindows);
